<script>
import ModalDetalleValidaciones from "../cargaCfdiAddenda/modal/ModalDetalleValidaciones.vue";
import { PaginationWithRangeMix } from "../../../mixes/PaginationMix.js";
import Loader from "./../../widgets/loader.vue";
import { service } from "../../../helpers/service.js";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import useVuelidate from "@vuelidate/core";
import { validator } from "../../../helpers/validador.js";
import {
    required
} from "@vuelidate/validators";

const headers = [
  {
    index: "nombre_archivo",
    label: "Nombre archivo",
    filter: false,
  },
  {
    index: "uuid_cfdi",
    label: "UUID CFDI",
    filter: false,
  },
  {
    index: "resultado_carga",
    label: "Resultado carga",
    filter: false,
    selected: false,
  },
  {
    index: "error",
    label: "Error",
    filter: false,
    selected: false,
  },
  {
    index: "detalle_mensaje",
    label: "Detalle",
    filter: false,
    selected: false,
  },
];

const acceptXML = ".xml,text/application";
/**
 * Addendador Component
 */
export default {
    name: "Addendador",
    mixins: [PaginationWithRangeMix],
	setup(){
		return {v$:useVuelidate()};
	},
    components: {
        Layout,
        PageHeader,
        Loader,
        "view-detail": ModalDetalleValidaciones
    },
    data() {
        return {
            sucursales: [],
            search:{
                nombre:"",
                email:"",
                extern_code: "",
                status: "1",
            },
            habilitarBotonAgregarEditarAddenda: false,
            showModalDetalleValidaciones: false,
            mostrarTablaResultadoCarga: false,
            cfdisACargar : {
                cfdi_set:[]
            },
            listaRespuestaRecepcion: {
                proveedor_correo: "",
                proveedor_rfc: "",
                uid: "",
                file_number: 0,
                status: "",
                created_at: "",
                origin: "",
                cfdi_set : []
            },
            listaRespuestaRecepcionParaPaginacion: {
                proveedor_correo: "",
                proveedor_rfc: "",
                uid: "",
                file_number: 0,
                status: "",
                created_at: "",
                origin: "",
                cfdi_set : []
            },
            headers,
            updating: false,
            title: "Addendador",
            showTitle: "",
            message: "Arrastra el XML a subir",
            extensionsXML: ['xml'],
            accept: acceptXML,
            maxNumberOfFilesXml: 1,
            buttonSelectMessage: "Seleccionar archivo",
            addenda724: {
                fecha_entrega: "",
                rfc: "",
                sucursal: "S001",
                numero_factura: ""
            },
            cfdiData: undefined,
            cfdiConAddenda: undefined,
            nodoAddenda: undefined,
            tamanoColleccion: 0
        };
    },
	validations: {
		addenda724:{
			fecha_entrega: {
				required,
                customBetween(value){
                    let [year, month, day]  = value.split("-").map(Number);
                    let fechaDeEntrega      = new Date(year, month - 1, day);

                    let now             = new Date();
                    let yearAuxiliar    = now.getFullYear();
                    let monthAuxiliar   = String(now.getMonth() + 1).padStart(2,"0");
                    let dayAuxiliar     = String(now.getDate()).padStart(2,"0");

                    let nowValidation       = new Date(yearAuxiliar, monthAuxiliar - 1, dayAuxiliar);
                    let aThreeAgoValidation = new Date(yearAuxiliar, monthAuxiliar - 1, dayAuxiliar);

                    aThreeAgoValidation.setFullYear(aThreeAgoValidation.getFullYear() - 3);

                    return fechaDeEntrega >= aThreeAgoValidation && fechaDeEntrega <= nowValidation;
                },
			},
			rfc: {
				required,
                customIsValidRfcSatImpl: validator.isValidRFCSatImpl,
                customIsValidLengthRfc: validator.isValidLengthRfc
			},
			numero_factura: {
				required
			}
		}
	},
    mounted() {
        this.setFechaHoy();
        this.getCollectionSize();
    },
    methods: {
        async getCollectionSize(){
            try {
                this.pagination.columnName = 'extern_code';
                this.pagination.sortOrder = 'ASC';
                const tablePagination = this.pagination;
                const query = Object.assign(this.search);
                const pag = Object.assign({}, tablePagination);
                pag.query = query;

                this.updating=true;

                const response = await service.getSucursales(pag);

                if(response.success === true){
                    this.tamanoColleccion = response.data.colletionSize;
                    this.getSucursales();
                }else{
                    await this.$confirm.error("Algo falló, no se pudo cargar el catalogo de sucursales");
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.updating=false;
            }            
        },
        async getSucursales(){
            try {
                this.pagination.columnName = 'extern_code';
                this.pagination.sortOrder = 'ASC';
                const tablePagination = this.pagination;
                tablePagination.pageSize = this.tamanoColleccion;
                const query = Object.assign(this.search);
                const pag = Object.assign({}, tablePagination);
                pag.query = query;

                this.updating=true;

                const response = await service.getSucursales(pag);

                if(response.success === true){
                    this.sucursales = response.data.data;
                }else{
                    this.sucursales = [];
                    await this.$confirm.error("Algo falló, no se pudo cargar el catalogo de sucursales");
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.updating=false;
            }            
        },
        async cargarCfdiConAddenda(){

            this.cfdisACargar.cfdi_set = [];

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });

            const processFile = async () => {
                const cfdiConAddendaBlob = new Blob([this.cfdiConAddenda], { type: 'text/plain' });

                try {
                    const response = await toBase64(cfdiConAddendaBlob);
                    const withoutMimeType = response.split(',')[1];
                    const resultado = { base64: withoutMimeType };
                    return resultado;
                } catch (error) {
                    console.error('Error al convertir a base64:', error);
                }
            };

            // Llamar la función
            let cfdiBase64 = await processFile();

            this.cfdisACargar.cfdi_set.push(
                {
                    xml:        cfdiBase64.base64,
                    pdf:        "dsadas",
                    reference:  this.cfdiData.item.name
                }
            );

            try {
                this.updating=true;

                const response = await service.cargarCfdiConAddenda(this.cfdisACargar);

                if(response.success){

                    this.listaRespuestaRecepcion.uid = response.data.uid;
                    this.listaRespuestaRecepcion.file_number = response.data.file_number;
                    this.listaRespuestaRecepcion.cfdi_set = response.data.cfdi_set;
                    this.mostrarTablaResultadoCarga = true;
                    this.manejarPaginacionCfdiSet();
                    this.$confirm.success('Carga completada');
                }else{
                    this.listaRespuestaRecepcion.cfdi_set = [];
                    await this.$confirm.error("Algo falló, intenta de nuevo por favor");
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.updating=false;
            }
        },
        manejarPaginacionCfdiSet(){
            const tablePagination = this.pagination;
            const pag = Object.assign({}, tablePagination);

            this.listaRespuestaRecepcionParaPaginacion = {
                ...this.listaRespuestaRecepcion,
                cfdi_set: [...this.listaRespuestaRecepcion.cfdi_set],
            };

            tablePagination.collectionSize = this.listaRespuestaRecepcionParaPaginacion.file_number;

            tablePagination.actualShow = pag.pageSize;

            // calculo de indices inicio y final para paginación
            const indiceInicio = (pag.page - 1) * pag.pageSize;
            const indiceFinal = pag.page * pag.pageSize;

            // corta array para listar elementos de la página actual
            this.listaRespuestaRecepcionParaPaginacion.cfdi_set = this.listaRespuestaRecepcionParaPaginacion.cfdi_set.slice(indiceInicio, indiceFinal);
        },
        async uploadFile(base64File) {
            this.mostrarTablaResultadoCarga = false;
            this.cfdiData = base64File;
            let payload = {
                xml: this.cfdiData.base64,
                addendumName:"724"
            }

            try {
                this.updating=true;
                
                const response = await service.agregarEditarAddenda(payload);

                if(response.success){
                    if(response.data.fecha_de_entrega != null && response.data.referencia_proveedor != null && response.data.referencia_sucursal != null && response.data.referencia_num_factura != null){

                        this.addenda724.fecha_entrega = response.data.fecha_de_entrega;
                        this.addenda724.rfc = response.data.referencia_proveedor;
                        this.addenda724.sucursal = response.data.referencia_sucursal;
                        this.addenda724.numero_factura = response.data.referencia_num_factura;

                        this.agregarEditarAddenda();

                        this.habilitarBotonAgregarEditarAddenda = true;

                    }else{
                        this.setFechaHoy();
                        this.addenda724.rfc = "";
                        this.addenda724.sucursal = this.sucursales[0].extern_code;
                        this.addenda724.numero_factura = "";
                        this.cfdiConAddenda = "";
                        this.nodoAddenda = "";
                        this.habilitarBotonAgregarEditarAddenda = true;
                    }
                }else{
                    this.habilitarBotonAgregarEditarAddenda = false;
                    console.log('uploadFile error');
                    console.log(response.data);
                    if(response.data == "Código 2301: Tipo de CFDI: Pago no aceptado."){
                        await this.$confirm.error("Error en addendador: No se permiten complementos de Pago");
                    }else{
                        await this.$confirm.error(response.data);
                    }
                }
            } catch (error) {
                console.log('error');
                console.log(error);
            } finally {
                this.updating=false;
            }
        },
        noEsUnCfdi(){
            this.cfdiData = undefined;
        },
		async agregarEditarAddenda(){
            this.mostrarTablaResultadoCarga = false;
			this.v$.$touch();
			if(this.v$.$invalid){
				await this.$confirm.error("Completa los campos requeridos");
				return;
			}

            // aqui debe ir la llamada al servicio que tomara el contenido de this.cfdiData y this.addenda724 para agregar la addenda al xml y devolvera el xml para visualizar
            let payload = {
                xml: this.cfdiData.base64,
                addendumName:"724",
                724:{
                    FechadeEntrega:this.addenda724.fecha_entrega,
                    Referencia: this.addenda724.rfc + "," + this.addenda724.sucursal + "," + this.addenda724.numero_factura
                }
            }

            try {
                this.updating=true;

                const response = await service.agregarEditarAddenda(payload);

                if(response.success){
                    console.log('success true');
                    console.log(response.data);
                    this.cfdiConAddenda = response.data.xml;
                    this.nodoAddenda = response.data.addendum;
                }else{
                    await this.$confirm.error(response.data);
                }
            } catch (error) {
                console.log('error');
                console.log(error);
            } finally {
                this.updating=false;
            }
		},
        setFechaHoy(){
            let now     = new Date();
            let year    = now.getFullYear();
            let month   = String(now.getMonth() + 1).padStart(2,"0");
            let day     = String(now.getDate()).padStart(2,"0");

            this.addenda724.fecha_entrega = `${year}-${month}-${day}`;
        },
    },
    computed: {
        extensions: function () {
            return this.extensionsXML
        },
        disableButtonAgregarAddenda:function(){
            return !this.cfdiData;
        },
        disableButtonCargarAddenda:function(){
            return !this.cfdiConAddenda;
        },
        xmlFormatted() {
            if (!this.cfdiConAddenda) return "";
            try {
                return this.cfdiConAddenda;
            } catch (error) {
                return "Error al decodificar XML.";
            }
        },  
        xmlFormattedAddenda(){
            if(!this.nodoAddenda){
                return "";
            }
            try {
                return this.nodoAddenda;
            } catch (error) {
                return "Error al decodificar XML.";
            }
        }
    },
    watch: {
        "addenda724.rfc": function(newVal){
            let lastChar = newVal.charAt(newVal.length - 1);
            if(lastChar == lastChar.toLowerCase()){
                this.addenda724.rfc = newVal.toUpperCase();
            }
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader title="Addendador" />
        <Loader :loading="updating">
        <div class="row">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <upload-file-d 
							:show-button-upload-files="false" 
							:show-gallery="false" 
							:show-table="true"
                            :message="message" 
							:accept="accept" 
							:show-progress="false"
                            :maxNumberOfFilesXml="maxNumberOfFilesXml" 
                            :showTitle="showTitle" 
                            :extensions="extensions"
                            :buttonSelectMessage="buttonSelectMessage"
                            :showButtonUploadInTableRow="false"
                            @uploadSelectedBase64File="uploadFile($event)"
                            @noEsUnCfdi="noEsUnCfdi"></upload-file-d>
                    </div>
                    <hr>
                    <div class="row" v-if="habilitarBotonAgregarEditarAddenda">
                        <label for="">
                            <b>
                                Addenda 7/24
                            </b>
                        </label>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="fechaPago">Fecha de Entrega <span style="color: red">*</span>:</label>
                            <input id="fecha-entrega" type="date" class="form-control" v-model="addenda724.fecha_entrega" :class="{'is-invalid':v$.addenda724.fecha_entrega.$error}"/>
							<div v-if="v$.addenda724.fecha_entrega.$error" class="invalid-feedback">
								<span v-if="v$.addenda724.fecha_entrega.required.$invalid">
									La fecha de entrega es requerida
								</span>
                                <span v-if="v$.addenda724.fecha_entrega.customBetween.$invalid">
                                    Puede ser hasta 3 años atras apartir de la fecha actual
                                </span>
							</div>							
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="rfcProveedor">RFC <span style="color: red">*</span>:</label>
                            <input type="text" class="form-control" maxlength="13" v-model.trim="addenda724.rfc" :class="{'is-invalid':v$.addenda724.rfc.$error}">
							<div v-if="v$.addenda724.rfc.$error" class="invalid-feedback">
								<span v-if="v$.addenda724.rfc.required.$invalid">
									RFC es requerido
								</span>
                                <span v-if="v$.addenda724.rfc.customIsValidRfcSatImpl.$invalid">
                                    Formato inválido
                                </span>
                                <span v-if="v$.addenda724.rfc.customIsValidLengthRfc.$invalid">
                                    Deben ser 13 caracteres para persona fisica o 12 para persona moral.
                                </span>
							</div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="sucursal">Sucursal <span style="color: red">*</span>:</label>
                            <select class="form-select" id="idSucursal" v-model="addenda724.sucursal">
                                <option v-for="item in sucursales" :key="item.id" :value="item.extern_code">
                                    {{ item.extern_code }}
                                </option>
                            </select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="numFactura">No. Factura <span style="color: red">*</span>:</label>
                            <input type="text" title="Número de Factura / Número de Remisión de Sucursal" class="form-control" maxlength="50" v-model.trim="addenda724.numero_factura" :class="{'is-invalid':v$.addenda724.numero_factura.$error}">
							<div v-if="v$.addenda724.numero_factura.required.$invalid" class="invalid-feedback">
								<span v-if="v$.addenda724.numero_factura.required.$invalid">
									El numero de factura es requerido
								</span>
							</div>
                        </div>
                    </div>
                    <div class="row mt-3" v-if="habilitarBotonAgregarEditarAddenda">
                        <div class="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end">
                            <button class="btn btn-success" title="Agregar/Editar addenda" @click="agregarEditarAddenda" :disabled="!habilitarBotonAgregarEditarAddenda">Agregar/Editar addenda</button>
                        </div>
                    </div>
                    <hr>
                    <div class="row" v-if="habilitarBotonAgregarEditarAddenda">
                        <label for="">
                            <b>
                                Previsualización de la addenda
                            </b>
                        </label>
                        <tabs :options="{ useUrlFragment: false, defaultTabHash: 'nodoAddenda724' }">
                            <tab id="nodoAddenda724" name="Addenda 7/24">
                                <pre v-highlightjs="xmlFormattedAddenda">
                                    <code class="javascript"></code>
                                </pre>
                            </tab>
                            <tab id="Cfdi" name="CFDI">
                                <pre v-highlightjs="xmlFormatted">
                                    <code class="javascript"></code>
                                </pre>
                            </tab>
                        </tabs>
                    </div>
                    <div class="row mt-3" v-if="!disableButtonCargarAddenda">
                        <div class="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end">
                            <button class="btn btn-success" :disabled="disableButtonCargarAddenda" title="Cargar CFDI" @click="cargarCfdiConAddenda">
                                Cargar CFDI
                                <i class="fa fa-file-upload"></i>
                            </button>
                        </div>
                    </div>
                    <div class="row" v-if="this.mostrarTablaResultadoCarga">
                        <label>ID recepción: {{ this.listaRespuestaRecepcion.uid }}</label>
                        <table-pagination 
                            :headers="headers" 
                            :pagination="pagination"
                            @on-pagination="pagination = $event"
                            :callback-search="manejarPaginacionCfdiSet"
                        >
                            <template v-slot:tbody>
                                <tr class="table-hover" v-for="item in listaRespuestaRecepcionParaPaginacion.cfdi_set" :key="item.index">
                                    <td>{{ item.reference }}</td>                                    
                                    <td>{{ item.uuid }}</td>
                                    <td>
                                        <span class="badge" :class="item.status == 'ACCEPTED' ? 'bg-success' : 'bg-danger'">
                                            {{item.status == 'ACCEPTED' ? "ACEPTADO" : "RECHAZADO" }}
                                        </span>
                                    </td>
                                    <td>
                                        <div v-for="stage in item.stage_history.stages.filter(stage => !stage.passed)" :key="stage.name">
                                            <div class="texto-error">
                                                {{ stage.validation_error }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            id="btn_detail_reception"
                                            title="Detalle validaciones"
                                            class="btn btn-sm btn-info"
                                            @click="(showModalDetalleValidaciones = true), (data_to_send = item.stage_history)"
                                        >
                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </table-pagination>
                    </div>
                </div>
            </div>
        </div>
        </Loader>
        <view-detail
            :show-modal="showModalDetalleValidaciones"
            v-on:on-hide="showModalDetalleValidaciones = false"
            :stage_history="data_to_send"
        >
        </view-detail>
    </Layout>
</template>
<style>
pre {
  padding-left: 20px;
}

code {
  padding-left: 20px;
  display: block;
  white-space: pre-wrap;
}

@media (min-width: 700px) {
    .tabs-component-tabs {
        border: 0;
        align-items: stretch;
        display: flex;
        justify-content: flex-start;
        margin-bottom: -1px;
        padding-left: 0
    }
}

.tabs-component-tab, .tabs-component-tab--custom {
    color: #999;
    font-size: 14px;
    font-weight: 600;
    margin-right: 0;
    list-style: none;
}

.tabs-component-tab:hover {
    color: #666;
}

.tabs-component-tab.is-active {
    color: #000;
}

.tabs-component-tab.is-disabled *, .tabs-component-tab--custom.is-disabled * {
    color: #cdcdcd;
    cursor: not-allowed !important;
}

@media (min-width: 700px) {
    .tabs-component-tab, .tabs-component-tab--custom {
        background-color: #fff;
        border: solid 1px #ddd;
        border-radius: 3px 3px 0 0;
        /* margin-right: .5em; */
        transform: translateY(2px);
        transition: transform .3s ease;
    }

    .tabs-component-tab.is-active, .tabs-component-tab--custom.is-active {
        border-bottom: solid 1px #fff;
        z-index: 2;
        transform: translateY(0);
    }
}

.tabs-component-tab-a, .tabs-component-tab-a--custom {
    align-items: center;
    color: inherit;
    display: flex;
    padding: .75em 1em;
    text-decoration: none;
}

.tabs-component-panels {
    padding: 4em 0;
}

@media (min-width: 700px) {
    .tabs-component-panels {
        background-color: #fff;
        border: solid 1px #ddd;
        border-radius: 0 6px 6px 6px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .05);
        padding: 4em 2em;
    }
}

.tabs-component-btn {
  cursor: pointer;
  background: #e1ecf4;
  border-radius: 3px;
  border: 1px solid #7aa7c7;
  padding: 4px 8px;
  color: #39739d;
}

.tabs-component-btn:hover {
  background-color: #b3d3ea;
  color: #2c5777;
}

.tabs-component-btn:active {
  background-color: #a0c7e4;
  box-shadow: none;
  color: #2c5777;
}

.tabs-component-tab--custom {
    border-color: #e1ecf4;
    color: #68838d;
}

.tabs-component-tab--custom:hover {
    border-color: #e1ecf4;
    color: #39739d;
}

.tabs-component-tab--custom.is-active {
    color: #39739d;
    border-color: #7aa7c7;
    border-bottom: solid 1px #fff;
}
</style>